import { SkillsPerformance } from "@/reports/types";

export interface QuizDataValues {
  average_quiz_score: number | null;
  student_count: number;
  quiz_count: number;
}

export interface QuizData {
  [key: string]: QuizDataValues;
}

const shapeQuizPerformanceData = (
  data:
    | QuizData
    | Pick<SkillsPerformance, "average_question_score" | "student_count">,
) => {
  return Object.entries(data).reduce((accumulator, [key, value]) => {
    return {
      ...accumulator,
      [key]: {
        percentageValue:
          value.average_quiz_score | value.average_question_score,
        labelValue: value.quiz_count | value.question_count,
      },
    };
  }, {});
};

export default shapeQuizPerformanceData;
